<ng-template #template let-item="item">
  <div class="headline" [ngClass]="{ 'normalize-line-height': options.showCostCenter && item.costCenter }">{{ item.name }}</div>
  @if(options.showCostCenter && item.costCenter) {
    <div class="subline normalize-line-height">
      {{ item.costCenter }}
    </div>
  }
</ng-template>
